module.exports = __webpack_public_path__ + "static/img/per1 (13).6099927.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/per1 (13).png
// module id = PrIn
// module chunks = 1